import type { FactionId } from '@sd/content';
import type { PlanetKind } from '@sd/sim';

/** Visual palette for the low-poly style. Gameplay never reads these. */
export const FACTION_COLORS: Readonly<Record<FactionId, string>> = {
  earthborn: '#4fa3ff',
  reforged: '#ff6a3d',
  drifters: '#e3b64c',
  skyborn: '#8ff0e0',
};

/**
 * Seat colours on the map and in the UI (docs/design/ui-style.md): one per
 * seat, cool or pink so a player never reads as the star. Same as the
 * --seat-N tokens in ui/tokens.css.
 */
export const SEAT_COLORS = ['#4fa3ff', '#5fe0c8', '#a98bff', '#ff7eb6'] as const;
export const PIRATE_COLOR = '#d9d2c3';

/** Colour of a player id `pN`: the seat N. */
export function seatColorHex(playerId: string): string {
  const seat = Number(playerId.replace(/\D/g, ''));
  return SEAT_COLORS[seat - 1] ?? PIRATE_COLOR;
}

export const PLANET_COLORS: Readonly<Record<PlanetKind, string>> = {
  lava: '#d9532c',
  desert: '#d8a75a',
  terran: '#4c9a6a',
  asteroids: '#8a8173',
  gasGiant: '#c99a6b',
  ice: '#bcd8e8',
};

export const SCENE_COLORS = {
  background: '#06070d',
  /** Tile fills, drawn about a tenth opaque over space (#99). */
  tile: '#5a6c9e',
  tileOrbit: '#7d95d6',
  tileCorona: '#d08a4a',
  /** The grid's thin outlines. */
  tileEdge: '#6e80b8',
  /** The veil over what the player has never seen (#97, #99). */
  shroud: '#04050b',
  cloud: ['#b59be0', '#86b8d8', '#d79ac0'],
  outline: '#0b0d14',
  /** The star's heat on tiles a crisis will strike (warm colours belong to the star). */
  strike: '#ff9a3c',
} as const;
